"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonLogic = void 0;
const json_logic_js_1 = __importDefault(require("json-logic-js"));
exports.jsonLogic = json_logic_js_1.default;
const date_1 = require("../date");
const operators_1 = require("./operators");
// Configure JsonLogic
for (const operator in operators_1.operators) {
    json_logic_js_1.default.add_operation(`_${operator}`, operators_1.operators[operator]);
}
// Retrieve Any Date
json_logic_js_1.default.add_operation('getDate', (date) => {
    return (0, date_1.dayjs)(date).toISOString();
});
// Set Relative Minimum Date
json_logic_js_1.default.add_operation('relativeMinDate', (relativeMinDate) => {
    return (0, date_1.dayjs)().subtract(relativeMinDate, 'days').toISOString();
});
// Set Relative Maximum Date
json_logic_js_1.default.add_operation('relativeMaxDate', (relativeMaxDate) => {
    return (0, date_1.dayjs)().add(relativeMaxDate, 'days').toISOString();
});
